// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"5f1b39993847a9364636","678":"2519dbaff4d519ab03e5","731":"1e740cbee7eefe4bf734","843":"66795ece6c86ab20b986","883":"9e8d4dbe8e0fe3ed53f6"}[chunkId] + ".js";
};